import React, { useState } from "react";
import Header from "../components/simswap/Header";
import SimSwapOverview from "../components/simswap/SimSwapOverview";

const SimSwap = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    status: "",
    fromDate: "",
    toDate: "",
  });

  return (
    <div>
      <Header searchTerm={searchTerm} filters={filters} />
      <SimSwapOverview
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        filters={filters}
        setFilters={setFilters}
      />
    </div>
  );
};

export default SimSwap;
